/**
 * Selector for all supported hwe kernel.
 */

import { generateGeneralSelector } from "./utils";

const hweKernels = generateGeneralSelector<"hweKernels">("hweKernels");

export default hweKernels;
